import { emailTemplateSchema } from "@redotech/redo-model/email-template";

export const createEmailTemplate = {
  name: "createEmailTemplate" as const,
  input: emailTemplateSchema.omit({ _id: true }),
  output: emailTemplateSchema,
};
